import { defineMessages, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Checkbox } from '~/eds/src/components/Checkbox/Checkbox';
import { Layout } from '~/eds/src/components/Layout/Layout';

export interface AddToGroupFooterProps {
  onBack: () => void;
  onNext: () => void;
  isActionDisabled?: boolean;
  keepFormOpen?: boolean;
  onChangeKeepFormOpen?: (value: boolean) => void;
}

const messages = defineMessages({
  cancel: {
    id: 'AddToGroupFooter.cancel',
    defaultMessage: 'Cancel',
    description: 'Button text to cancel add to group flow',
  },
  addToGroup: {
    id: 'AddToGroupFooter.addToGroup',
    defaultMessage: 'Add to Group',
    description: 'Button text to add item to group',
  },
  keepFormOpen: {
    id: 'AddToGroupFooter.keepFormOpen',
    defaultMessage: 'Keep form open and add another',
    description:
      'Checkbox label to keep the add to group panel open after submitting',
  },
});

export const AddToGroupFooter = ({
  onBack,
  onNext,
  isActionDisabled = false,
  keepFormOpen = false,
  onChangeKeepFormOpen,
}: AddToGroupFooterProps) => {
  const { formatMessage } = useIntl();

  return (
    <Layout align="center" justify="space-between" w="100%">
      <Checkbox
        name="keepFormOpen"
        option={{
          label: formatMessage(messages.keepFormOpen),
          value: 'keepFormOpen',
        }}
        value={keepFormOpen}
        onChange={(checked) => onChangeKeepFormOpen?.(checked ?? false)}
      />
      <Layout align="center" spacing={2}>
        <Button
          text={formatMessage(messages.cancel)}
          variant="tertiary"
          onClick={onBack}
        />
        <Button
          text={formatMessage(messages.addToGroup)}
          variant="primary"
          onClick={onNext}
          disabled={isActionDisabled}
        />
      </Layout>
    </Layout>
  );
};
